import React from 'react';
import { submitOrgSignupApi } from '../../redux/Reducers/commonApis';
import toast from 'react-hot-toast';
import { getProfileDataApi } from '../../redux/Reducers/ProfileReducer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';

export default function CreateAccount({ accountData, data, token }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [acceptedTos, setAcceptedTos] = React.useState(false);
  const [createAccountLoading, setCreateAccountLoading] = React.useState(false);
  const [isPasswordValid, setIsPasswordValid] = React.useState(false);
  const meetsPasswordPolicy = (val) => {
    return val?.length >= 8 && /[A-Z]/.test(val) && /[a-z]/.test(val) && /\d/.test(val);
  };
  const canSubmit = acceptedTos && isPasswordValid;

  const handleCreateAccount = async (e) => {
    setCreateAccountLoading(true);
    e.preventDefault();
    if (!canSubmit) return;
    const payload = {
      password,
      confirm_password: password,
      token,
      business_name: accountData?.organization_name || data?.organization_name,
      org_admin_first_name: accountData?.first_name || data?.first_name,
      org_admin_last_name: accountData?.last_name || data?.last_name,
      org_admin_email: accountData?.email,
      org_admin_phone: (accountData?.phone_numbers || [])
        .filter((p) => p?.phone_number)
        .map((p) => ({ phone_number: p.phone_number })),
      billing_contact_first_name: accountData?.billing_contact_first_name || data?.first_name,
      billing_contact_last_name: accountData?.billing_contact_last_name || data?.last_name,
      billing_contact_email: accountData?.billing_contact_email || data?.email,
      billing_contact_phone_number: (accountData?.billing_contact_phone_number || [])
        .filter((p) => p?.phone_number)
        .map((p) => ({ phone_number: p.phone_number })),
    };
    const res = await submitOrgSignupApi(payload);
    if (res?.status === 200) {
      setCreateAccountLoading(false);
      toast.success('Account created successfully! Logging you in...');
      if (res?.data) {
        res.data.refresh_expires_date = new Date(new Date().getTime() + res?.data?.refresh_expires_in * 1000);
        localStorage.setItem('auth', JSON.stringify(res?.data));
        const getProfileData = dispatch(getProfileDataApi());
        getProfileData?.then((res) => {
          if (res?.status === 200) {
            navigate('/dashboard');
          }
        });
      }
    } else {
      setCreateAccountLoading(false);
      toast.error(res?.message || 'Failed to create account');
    }
  };

  return (
    <div className='relative mx-auto w-full space-y-6 px-2 pb-6 pt-4'>
      <div className='rounded-2xl bg-white p-6 shadow-lg sm:p-8'>
        <h2 className='h- mb-6 text-xl font-bold text-[#1e3a5f]'>Login Info</h2>
        {createAccountLoading ? (
          <Loader text='Creating account...' classes=' h-72' />
        ) : (
          <div className='space-y-4'>
            <div>
              <p className='mb-1 text-sm font-medium text-gray-400'>Username:</p>
              <p className='break-all text-base font-medium text-gray-700'>{accountData?.email}</p>
            </div>
            <div>
              <p className='mb-1 text-sm font-medium text-gray-400'>Password:</p>
              <div className='relative'>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPassword(val);
                    setIsPasswordValid(meetsPasswordPolicy(val));
                  }}
                  placeholder='••••••••'
                  className='w-full rounded-lg border border-gray-300 px-3 py-2 text-base font-medium text-gray-700 focus:border-blue-500 focus:outline-none'
                />
                <button
                  type='button'
                  onClick={() => setShowPassword((s) => !s)}
                  className='absolute right-3 top-1/2 -translate-y-1/2 text-sm text-blue-600 hover:text-blue-700'
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              {!isPasswordValid && (
                <p className='mt-1 text-xs text-[#548ff7]'>
                  * Passwords must be at least 8 characters, include 1 upper case and 1 lower case letters, and 1
                  number.
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Terms of Service Card */}
      <div className='rounded-2xl bg-white p-6 shadow-lg sm:p-8'>
        <h2 className='mb-4 text-xl font-bold text-[#1e3a5f]'>Terms of Service</h2>
        <div className='flex items-start justify-between gap-4'>
          <p className='max-w-[85%] text-base leading-6 text-gray-700'>
            By submitting this form you are accepting the quote and terms as emailed to you based on the details you
            provided of your laundry needs.
          </p>
          <input
            type='checkbox'
            checked={acceptedTos}
            onChange={(e) => setAcceptedTos(e.target.checked)}
            className='mt-1 h-5 w-5 accent-blue-600'
          />
        </div>
      </div>

      {/* Actions */}
      <div className='space-y-3'>
        <button
          onClick={handleCreateAccount}
          disabled={!canSubmit}
          className={`w-full rounded-full px-4 py-3 text-center text-lg font-semibold text-white transition ${
            canSubmit ? 'hover:bg-client-lcpink bg-client-lcpink' : 'bg-client-lcpink cursor-not-allowed opacity-50'
          }`}
        >
          Create Account
        </button>
      </div>
    </div>
  );
}
